// import cookie from 'react-cookies';
import cookie from 'react-cookies';

export function storeLocally(itemName, itemValue, age) {
  localStorage.setItem(itemName, JSON.stringify(itemValue));
  cookie.save(itemName, JSON.stringify(itemValue), {
    path: '/',
    // domain: '.jidipi.com',
    maxAge: age || 100000,
  });
  if (itemValue && itemValue.user)
    cookie.save('user', JSON.stringify(itemValue.user), {
      path: '/',
      domain: '.jidipi.com',
      maxAge: age || 100000,
    });
  if (itemValue && itemValue.token)
    cookie.save('token', JSON.stringify(itemValue.token), {
      path: '/',
      domain: '.jidipi.com',
      maxAge: age || 100000,
    });
}

export function getJsonFromLocalStorage(key) {
  return JSON.parse(localStorage.getItem(key));

  // return cookie.load(key);
}

export function removeFromLocalStorage(key) {
  cookie.remove(key, {
    path: '/',
    domain: '.jidipi.com',
  });
  return localStorage.removeItem(key);
}
